import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import AttachmentItemsPagingMetadata from 'owa-service/lib/contract/AttachmentItemsPagingMetadata';
import AttachmentItemsSort from 'owa-service/lib/contract/AttachmentItemsSort';
import AttachmentResultCode from 'owa-service/lib/contract/AttachmentResultCode';
import datapoints from '../../datapoints';
import GetFileProviderItemsResponse from '../../types/GetFileProviderItemsResponse';
import searchFileProviderItemsService from '../../utils/getOrSearchFileProviderItems/searchFileProviderItems';
import TokenResponseCode from 'owa-service/lib/contract/TokenResponseCode';
import { createLegacyActionWithDatapoint } from 'owa-analytics-actions';
import { isTokenRetrievalError } from 'owa-fileprovider-accesstoken-service';

// FPSearchItems has customData that is called on the getFileProviderItems input parameters.
// If you change the input params make sure to update FPGetItems in datapoints.ts to match.

/**
 * If an error is encountered and the promise is broken we throw an AttachmentResultCode that is handled by the caller.
 */
export default createLegacyActionWithDatapoint(
    'searchFileProviderItems',
    datapoints.FPSearchItems
)(async function searchFileProviderItems(
    fileProviderType: AttachmentDataProviderType,
    fileProviderId: string,
    searchQuery: string,
    offset: number,
    folderId?: string,
    location?: string,
    pagingMetadata: AttachmentItemsPagingMetadata = null,
    sort?: AttachmentItemsSort
): Promise<GetFileProviderItemsResponse> {
    try {
        // disabling tslint rule as we need to await here
        // for the catch block to work properly
        // https://github.com/palantir/tslint/issues/3933
        // tslint:disable-next-line:no-return-await
        return await searchFileProviderItemsService(
            fileProviderType,
            fileProviderId,
            searchQuery,
            offset,
            folderId,
            location,
            pagingMetadata,
            sort
        );
    } catch (error) {
        if (isTokenRetrievalError(error)) {
            if (error.resultCode === TokenResponseCode.Unauthorized) {
                // If the error is a token response code unauthorized then it is similar
                // to the Access denied error code from AttachmentResultCode
                throw AttachmentResultCode.AccessDenied;
            }
        }

        // Otherwise rethrow
        throw error;
    }
});
